import * as React from 'react';

function SvgMenu(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.97 18.95" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.98 1.92a1.88 1.88 0 01-1.87 1.92H1.87A1.88 1.88 0 01-.02 1.92 1.87 1.87 0 011.87-.02h20.3a1.87 1.87 0 011.81 1.94zM23.98 9.44a1.88 1.88 0 01-1.87 1.91H1.87A1.87 1.87 0 01-.02 9.44a1.87 1.87 0 011.89-1.92h20.3a2 2 0 011.81 1.92zM23.98 17.03a1.88 1.88 0 01-1.88 1.95H1.87a1.87 1.87 0 01-1.89-1.95 1.88 1.88 0 011.87-1.92h20.3a1.87 1.87 0 011.83 1.92z" />
    </svg>
  );
}

const MemoSvgMenu = React.memo(SvgMenu);
export default MemoSvgMenu;
